import valuer_api from "../../api/valuer";
import {useEffect, useState} from "react";
import ValuerAmendFieldListHandler from "./ValuerAmendFieldListHandler";


const ValuerAmendFreeTextInput = (props) => {

    // For Saving
    const summaryId = props.summaryId
    const section = props.sectionName
    const identifier = props.identifier

    // Optional
    const field = props.field
    const placeholder = props.placeholder ? props.placeholder : ""
    const fieldInfo = props.fieldInfo
    const infoColor = props.infoColor ? props.infoColor : "#000000"
    const defaultValue = props.defaultValue ? props.defaultValue : ""
    const textLimit = props.textLimit ? props.textLimit : false
    const flex = props.flex ? props.flex : false
    const rowId = props.rowId ? props.rowId : false

    // Sizing
    const width = props.width ? props.width : '100%'
    const height = props.height ? props.height : '100%'
    const minHeight = props.minHeight ? props.minHeight : '48px'
    const minWidth = props.minWidth ? props.minWidth : '0'

    // Value
    const [value, setValue] = useState("")
    const [valueLength, setValueLength] = useState(0)

    // Additional Fields
    const sectionValues = props.sectionValues ? props.sectionValues : {}
    const showValueDependantFields = props.showValueDependantFields ? props.showValueDependantFields : false
    const valueDependantFields = props.valueDependantFields ? props.valueDependantFields : []

    // Saving Tracker
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        if (!value) return;
        if (value.length) {
            setValueLength(value.length)
        } else {
            setValueLength(0)
        }
    }, [value]);

    useEffect(() => {
        if (props.value !== undefined) {
            if (props.value === null && defaultValue) {
                setValue(defaultValue)
            } else if (props.value === null) {
                setValue("")
            } else if (typeof props.value === "object") {
                setValue(JSON.stringify(props.value, null, 4))
            } else setValue(props.value)
        }
    }, [props.value, defaultValue])


    const UpdateValue = () => {
        let updateTime = Date.now();
        AddToQueue(section, identifier, updateTime);

        let body = { "value": value };
        if (rowId) body["row"] = rowId;

        let response = valuer_api.ValuerAmendPut(summaryId, section, identifier, body);
        response.then(() => {
            RemoveFromQueue(section, identifier, updateTime);
        }).catch((err) => {
            AddToErroredSaves(section, identifier, updateTime);
            setErrorTitle("Failed to Save");
            setErrorMessage("The request to save a field has failed");
        });
    };

    const ClickOff = () => {
        // Check for required fields and then submit change
        if (!summaryId || !section || !identifier) return
        UpdateValue()
        if (UpdateParentValue) {
            UpdateParentValue(identifier, value);
        }
    }

    const address = sectionValues["location-address"] || "";
    const postcodeRaw = sectionValues["location-postcode"] || "";
    const postcode = postcodeRaw.replace(/\s+/g, "");
    const mapsQuery = encodeURIComponent(`${address} ${postcode}`);


    return (
        <>
            {identifier === "location-address" && (
                <div style={{ display: "flex", gap: "30px", flexWrap: "wrap", marginLeft: "20px", marginBottom: "8px", marginTop: "-20px" }}>
                    <a
                        href={`https://www.google.com/maps/search/${mapsQuery}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Google maps
                    </a>
                    <a
                        href={`https://www.findmyaddress.co.uk/search?query=${mapsQuery}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        FindMyAddress
                    </a>
                    <a
                        href={`https://uprn.uk/postcode/${postcode}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        UPRN
                    </a>
                    <a
                        href={`https://www.gov.uk/search?q=${mapsQuery}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Land Registry
                    </a>
                </div>
            )}


            {identifier === "alternative-local-area-council-link" && (
                <div style={{ marginBottom: "8px", fontSize: "14px", color: "#666" }}>
                    Find your local council here:{" "}
                    <a href="https://www.gov.uk/find-local-council" target="_blank" rel="noopener noreferrer">
                        gov.uk/find-local-council
                    </a>
                </div>
            )}

            <div className={"valuer-amend-free-text-field-container"  + (flex ? ' inline' : '')}
                 style={width !== '100%' ? {width: width, minWidth: minWidth} : {width: width, minWidth: minWidth, overflow: 'hidden'}}>
                {field && field ?
                    <div className="valuer-amend-field-label">{field}</div>
                    : null
                }
                {fieldInfo && fieldInfo ?
                    <div className="valuer-amend-field-info" style={{color: infoColor}} dangerouslySetInnerHTML={{__html: fieldInfo}}/>
                    : null
                }
                <div className="valuer-amend-field-input-container"
                     style={{width: width, height: height, minHeight: minHeight, minWidth: minWidth}}>
                    <textarea placeholder={placeholder} value={value} className="valuer-amend-field" disabled={props.disabled}
                          onChange={(ev) => {
                              if (textLimit) {
                                  if (ev.target.value.length > textLimit)
                                      setValue(ev.target.value.substring(0, textLimit))
                                  else setValue(ev.target.value)
                              }
                              else setValue(ev.target.value)}
                          }
                          onBlur={() => ClickOff()} defaultValue={defaultValue}/>

                </div>
                {!flex ?
                    <div className="valuer-amend-free-text-counter-container">
                        {valueLength + "/" + textLimit}
                    </div>
                :null}
            </div>
            {flex ?
                <div className="valuer-amend-free-text-counter-container end">
                    {`${value?.length ? value.length : "0"}/1024`}
                </div>
                :null}
            {valueDependantFields && valueDependantFields.map((fields, idx) => {
                return (
                    <>
                        {value && (fields.requirement && value === fields.requirement.value)
                        || value && (fields.antiRequirement && value !== fields.antiRequirement.value)
                            ? <ValuerAmendFieldListHandler fieldList={fields.fields}
                                                           sectionName={section}
                                                           summaryId={summaryId}
                                                           setErrorMessage={setErrorMessage}
                                                           setErrorTitle={setErrorTitle}
                                                           UpdateParentValue={UpdateParentValue}
                                                           AddToQueue={AddToQueue}
                                                           RemoveFromQueue={RemoveFromQueue}
                                                           AddToErroredSaves={AddToErroredSaves}/>

                            : (showValueDependantFields ?
                                <div className="valuer-amend-disabled-container">
                                    <ValuerAmendFieldListHandler fieldList={fields.fields}
                                                                 sectionName={section}
                                                                 summaryId={summaryId}
                                                                 setErrorMessage={setErrorMessage}
                                                                 setErrorTitle={setErrorTitle}
                                                                 values={sectionValues}
                                                                 UpdateParentValue={UpdateParentValue}
                                                                 AddToQueue={AddToQueue}
                                                                 RemoveFromQueue={RemoveFromQueue}
                                                                 AddToErroredSaves={AddToErroredSaves}/>
                                </div>
                                : null)
                        }
                    </>
                )
            })}
        </>
    )

}

export default ValuerAmendFreeTextInput